import { MdOutlineMonitor } from "react-icons/md";
import { RiCheckboxMultipleBlankLine } from "react-icons/ri";
import { useState } from "react";

import { toast } from "react-toastify";
import * as IconsSVG from "../../../../assets/iconsSVG";
import PesquisarCorretor from "./pesquisarCorretor";
import TabelaFila from "./tabelaFila";

import * as S from "./styles";

interface IOrdemFilaProps {
  dataListarFila: any;
  refetchListarFila: () => void;
}

const OrdemFila = ({ dataListarFila, refetchListarFila }: IOrdemFilaProps) => {
  const [palavraChave, setPalavraChave] = useState("");

  const filaCompleta = dataListarFila?.fila || [];

  const filaFiltrada = filaCompleta.filter((item: any) => {
    const termo = palavraChave.toLowerCase();
    const nomeCorretor = item?.nomeCorretor?.toLowerCase() || "";
    const equipeCorretor = item?.nomeEquipeCorretor?.toLowerCase() || "";
    const imobiliaria = item?.imobiliaria?.toLowerCase() || "";

    return (
      nomeCorretor.includes(termo) ||
      equipeCorretor.includes(termo) ||
      imobiliaria.includes(termo)
    );
  });

  return (
    <S.Container>
      <S.ContentTitle>
        <S.Row>
          <IconsSVG.FilaInscricaoIcon
            color1="#4CAF50"
            color2="#D1FADF"
            color3="#ECFDF3"
          />
          <S.Title>Ordem da Fila</S.Title>
        </S.Row>
        <S.Row style={{ gap: 8 }}>
          <S.Button
            onClick={() => {
              window.open(
                `/roleta-ao-vivo/${dataListarFila.idRoletaCheckin}`,
                "_blank"
              );
            }}
          >
            <MdOutlineMonitor size={20} />
            Roleta Ao Vivo
          </S.Button>
          <S.Button
            onClick={() => {
              navigator.clipboard.writeText(
                `${window.location.origin}/roleta-ao-vivo/${dataListarFila.idRoletaCheckin}`
              );
              toast.success("Link copiado com sucesso!");
            }}
            backgroundColor="#EAEFFF"
          >
            <RiCheckboxMultipleBlankLine size={20} />
            Copiar Link
          </S.Button>
        </S.Row>
      </S.ContentTitle>
      <S.ContentBody>
        <PesquisarCorretor
          onChangePalavraChave={(valor) => setPalavraChave(valor)}
          refetchListarFila={refetchListarFila}
        />
        <TabelaFila
          palavraChave={palavraChave}
          dataListarFila={{
            ...dataListarFila,
            fila: filaFiltrada,
          }}
          refetchListarFila={refetchListarFila}
        />
      </S.ContentBody>
    </S.Container>
  );
};
export default OrdemFila;
